export const COLORS: string[] = [
"#ff0000",
"#ffff00",
"#00ff00",
"#00ffff",
"#0000ff",
"#ff00ff",
"#ffffff",
"#e6e6e6",
"#dadada",
"#cdcdcd",
"#c1c1c1",
"#b4b4b4",
"#a7a7a7",
"#9a9a9a",
"#8e8e8e",
"#818181",
"#ed1c24",
"#fff200",
"#00a651",
"#00aeef",
"#2e3196",
"#ec008c",
"#737373",
"#666666",
"#595959",
"#4b4b4b",
"#3d3d3d",
"#303030",
"#212121",
"#131313",
"#0a0a0a",
"#000000",
"#f69679",
"#f9ad81",
"#fdc689",
"#fff799",
"#c4df9b",
"#a3d39c",
"#82ca9c",
"#7accc8",
"#6dcff6",
"#7da7d9",
"#8393ca",
"#8781bd",
"#a186be",
"#bd8cbf",
"#f49ac1",
"#f5989d",
"#f26c4f",
"#f68e56",
"#fbaf5d",
"#fff568",
"#acd373",
"#7cc576",
"#3cb878",
"#1cbbb4",
"#00bff3",
"#448ccb",
"#5674b9",
"#605ca8",
"#8560a8",
"#a864a8",
"#f06eaa",
"#f26d7d",
"#ed1c23",
"#f26522",
"#f7941d",
"#fff200",
"#8dc63f",
"#39b54a",
"#00a651",
"#00a99d",
"#00aeef",
"#0072bc",
"#0054a6",
"#2e3192",
"#662d91",
"#92278f",
"#ec008c",
"#ed145b",
"#9e0b0e",
"#a0410d",
"#a36209",
"#aba000",
"#598527",
"#197b30",
"#007236",
"#00746b",
"#0076a3",
"#004a80",
"#003471",
"#1b1464",
"#440e62",
"#630460",
"#9e005d",
"#9e0039",
"#790000",
"#7b2e00",
"#7d4900",
"#827b00",
"#406618",
"#005e20",
"#005826",
"#005952",
"#005b7f",
"#003663",
"#002157",
"#0d004c",
"#32004b",
"#4b0049",
"#7b0046",
"#7a0026",
"#c7b29a",
"#998675",
"#736157",
"#534741",
"#362f2d",
"#c69c6d",
"#a67c52",
"#8c6239",
"#754c24",
"#603913"
];



// WEBPACK FOOTER //
// ./src/app/models/colors.ts